import React from 'react';
import ExpiringAdmission from '../../crd/expiringAdmission/ExpiringAdmission';

export default function CroExpiringAdmission() {
  return <ExpiringAdmission CRO={true} />;
}
